import React from 'react';
import { Row, Col, Alert, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

import DropDownInput from './common/DropDownInput.jsx';

export default class Fitting1OrdererUploadComponent extends React.Component {

  componentDidMount() {
  }

  componentWillUnmount() {
    this.props.clearOrdererAlert();
  }

  uploadOrderer(forceUpload) {
    this.props.uploadOrderer({ orderId: this.props.orderId }, this.uploadOrdererFile, forceUpload);
  }

  deleteFittingRecord(duration) {
    let r = confirm('確認刪除 ?');
    if (r === true) {
      this.props.deleteFittingRecordByDuration({ orderId: this.props.orderId, duration: duration, type: 'Y' });
    }
  }

  render() {

    let alertDiv = null;
    let showForceUpload = this.props.showForceUpload;
    if (this.props.alertStyle || this.props.alertMessage) {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle} onDismiss={this.props.clearOrdererAlert}>
          {this.props.alertMessage}
        </Alert>
      );
    } else {
      showForceUpload = 'none';
    }

    let duratoin = 0;

    return (
      <div>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={12} md={12}>
            {alertDiv}
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12}>
            <label className="control-label" style={{ marginBottom: 20 }}>訂單編號: {this.props.orderId}</label>
          </Col>
          <Col xs={12} sm={12} md={12}>
            <FormGroup controlId="uploadOrdererFile" >
              <ControlLabel>訂購人 資料上傳</ControlLabel>
              <FormControl
                type="file"
                onChange={(event) => {
                  this.uploadOrdererFile = event.target.files[0];
                }}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12}>
            <Button style={{ marginRight: 10 }} onClick={(event) => {
              this.uploadOrderer();
            }} bsStyle="info">
              上傳
            </Button>
            <a className="btn btn-default" href="/files/orderer_import_app_example.xls" role="button">下載範例</a>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col xs={12} sm={3} md={3}>
            刪除本人新增資料
            <DropDownInput id="packingType"
              label=""
              options={[{ label: '一小時內', value: 1 }, { label: '一天內', value: 24 }, { label: '七天內', value: 168 }, { label: '三十天內', value: 720 }, { label: '九十天內', value: 2160 }]}
              onChange={(id, value, label) => {
                duratoin = value;
              }}
            />
            <Button style={{ marginRight: 10 }} onClick={(event) => {
              this.deleteFittingRecord(duratoin);
            }} bsStyle="default">
              <span className="glyphicon glyphicon-trash" style={{ marginRight: 10, color: '#a94442' }} />
              <span style={{ color: '#a94442' }}>刪除</span>
            </Button>
          </Col>
        </Row>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/Fitting1OrdererUploadComponent.jsx